import Bottomsheet from '@ixigo/iui/Bottomsheet';
import { useEffect, useLayoutEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DialogProps } from './index.types';

const Dialog = ({ children, classes, open, onClose, ...rest }: DialogProps) => {
    const [bottomsheetId] = useState(`bottomsheet-${uuidv4()}`);
    const [visible, setVisible] = useState(open);

    if (!classes) {
        classes = { root: 'lg:hidden', container: 'lg:hidden' };
    } else {
        classes.root = `${classes.root || ''} lg:hidden`;
        classes.container = `${classes.container || ''} lg:hidden`;
    }

    useEffect(() => {
        if (open) setVisible(open);
    }, [open]);

    useLayoutEffect(() => {
        if (!visible) return;

        const container = document.querySelector(`#${bottomsheetId}`);
        if (!container) return;

        const backdrop = document.querySelector(`#${bottomsheetId} div:first-child`) as HTMLDivElement;
        const bottomsheet = document.querySelector(`#${bottomsheetId} div:last-child`) as HTMLDivElement;

        backdrop.style.opacity = '0';
        bottomsheet.style.right = '-512px';
    }, [visible]);

    useEffect(() => {
        if (!visible) return;

        const container = document.querySelector(`#${bottomsheetId}`);
        if (!container) return;

        const backdrop = document.querySelector(`#${bottomsheetId} div:first-child`) as HTMLDivElement;
        const bottomsheet = document.querySelector(`#${bottomsheetId} div:last-child`) as HTMLDivElement;

        requestAnimationFrame(() => {
            queueMicrotask(() => {
                backdrop.style.opacity = '0.5';
                bottomsheet.style.right = '0px';
            });
        });
    }, [visible]);

    useEffect(() => {
        if (open) {
            setVisible(true);
            return;
        }

        const container = document.querySelector(`#${bottomsheetId}`);
        if (!container) return;

        const backdrop = document.querySelector(`#${bottomsheetId} div:first-child`) as HTMLDivElement;
        const bottomsheet = document.querySelector(`#${bottomsheetId} div:last-child`) as HTMLDivElement;

        requestAnimationFrame(() => {
            queueMicrotask(() => {
                backdrop.style.opacity = '0';
                bottomsheet.style.right = '-512px';
            });
        });
    }, [open]);

    if (!visible) return null;

    return (
        <>
            <div id={bottomsheetId} className='hidden fixed inset-0 z-[10000] lg:block'>
                <div
                    className='absolute inset-0 bg-black transition-opacity'
                    onTransitionEnd={() => {
                        if (!open) setVisible(false);
                    }}
                    onClick={onClose}
                />
                <div className='absolute flex flex-col min-w-96 max-w-lg h-full bg-white overflow-scroll transition-all duration-300'>
                    {children}
                </div>
            </div>
            <Bottomsheet classes={classes} open={open} onClose={onClose} {...rest}>
                {children}
            </Bottomsheet>
        </>
    );
};

export default Dialog;
